import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BrandedLoader from './ui/BrandedLoader';

const ProtectedRoute = () => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) return <BrandedLoader title="Opening your workspace" message="Checking your session, team access, and active products." />;

  if (!isAuthenticated) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login?reason=session_required&next=${next}`} replace />;
  }

  if (user?.mustChangePassword && location.pathname !== '/account-security') {
    return <Navigate to="/account-security" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
